import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/search_btn.png'


const _hoisted_1 = { class: "_action sub_page" }
const _hoisted_2 = { class: "sub_page_con wrap_1120" }
const _hoisted_3 = { class: "bread_crumbs" }
const _hoisted_4 = { class: "icon_wrap" }
const _hoisted_5 = ["alt"]
const _hoisted_6 = {
  href: "javascript:void(0)",
  style: {"cursor":"default"}
}
const _hoisted_7 = { class: "sub_con_banner" }
const _hoisted_8 = {
  key: 0,
  class: "remaining_time"
}
const _hoisted_9 = { class: "action_info" }
const _hoisted_10 = { class: "btn_wrap _default right_btn _board_type" }
const _hoisted_11 = { class: "search_wrap" }
const _hoisted_12 = { class: "list_table con_board sub_page_con_view suggestList" }
const _hoisted_13 = { class: "tr_div con_tit" }
const _hoisted_14 = { class: "tb_no no_768" }
const _hoisted_15 = { class: "tb_subject" }
const _hoisted_16 = {
  key: 0,
  style: {"margin-right":"3px"}
}
const _hoisted_17 = {
  key: 1,
  style: {"margin-right":"3px"}
}
const _hoisted_18 = { class: "tb_wr_name" }
const _hoisted_19 = { class: "tb_wr_name" }
const _hoisted_20 = { class: "tb_date_hour" }
const _hoisted_21 = {
  key: 1,
  class: "_flex _flex_100 _jc_sb"
}
const _hoisted_22 = { class: "_flex" }
const _hoisted_23 = { class: "tb_wr_name no_450" }
const _hoisted_24 = { class: "tb_wr_name" }
const _hoisted_25 = { class: "tb_date_hour" }
const _hoisted_26 = {
  key: 1,
  class: "tbody_li no_data"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PageBtn = _resolveComponent("PageBtn")!
  const _component_ModalDefault = _resolveComponent("ModalDefault")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_router_link, {
            to: "/",
            class: "icon_wrap"
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createElementVNode("img", {
                src: "img/home_icon.png",
                alt: "홈"
              }, null, -1)
            ]))]),
            _: 1
          }),
          _cache[6] || (_cache[6] = _createElementVNode("span", { class: "icon_wrap" }, [
            _createElementVNode("img", {
              src: "img/part_icon.png",
              alt: "액션 시민 활동"
            })
          ], -1)),
          _createVNode(_component_router_link, { to: { path: '/board', query: { type: 4 } } }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
              _createTextVNode("액션 시민 활동", -1)
            ]))]),
            _: 1
          }),
          _createElementVNode("span", _hoisted_4, [
            _createElementVNode("img", {
              src: "img/part_icon.png",
              alt: $setup.state.stateInfo.name
            }, null, 8, _hoisted_5)
          ]),
          _createElementVNode("a", _hoisted_6, _toDisplayString($setup.state.stateInfo.name), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("p", null, [
            _createTextVNode(_toDisplayString($setup.state.stateInfo.name) + " ", 1),
            (new Date() < new Date($setup.state.stateInfo.endDate))
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString($setup.CommonUtils.getDDayHour(new Date($setup.state.stateInfo.endDate))), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("p", null, [
              _cache[7] || (_cache[7] = _createElementVNode("span", null, "활동기간", -1)),
              _createTextVNode(" " + _toDisplayString($setup.CommonUtils.dateFormat(new Date($setup.state.stateInfo.startDate), ".", false)) + " ~ " + _toDisplayString($setup.CommonUtils.dateFormat(new Date($setup.state.stateInfo.endDate), ".", false)), 1)
            ]),
            _createElementVNode("p", null, [
              _cache[8] || (_cache[8] = _createElementVNode("span", null, "등록일", -1)),
              _createTextVNode(" " + _toDisplayString($setup.CommonUtils.dateFormat(new Date($setup.state.stateInfo.createDate), ".", false)), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: "제목 검색",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.state.searchText) = $event)),
              onKeydown: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => ($setup.getList && $setup.getList(...args)), ["enter"]))
            }, null, 544), [
              [_vModelText, $setup.state.searchText]
            ]),
            _createElementVNode("button", {
              class: "search_btn icon_wrap",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.getList && $setup.getList(...args)))
            }, [...(_cache[9] || (_cache[9] = [
              _createElementVNode("img", {
                "data-v-63e8d312": "",
                src: _imports_0,
                alt: ""
              }, null, -1)
            ]))])
          ]),
          ($setup.state.hasAuth && $setup.state.isActive)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "common_btn w_130",
                style: {"margin-bottom":"15px"},
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.loginConfirm && $setup.loginConfirm(...args)))
              }, " 글쓰기 "))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("ul", null, [
            _cache[20] || (_cache[20] = _createStaticVNode("<li class=\"thead_li\"><div class=\"tr_div con_tit\"><div class=\"tb_no\">번호</div><div class=\"tb_subject\">제목</div><div class=\"tb_wr_name\">조회수</div><div class=\"tb_wr_name\">작성자</div><div class=\"tb_date_hour\">작성일</div></div></li>", 1)),
            ($setup.state.list.length > 0)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.state.list, (item, idx) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "tbody_li",
                    key: item.idx
                  }, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, _toDisplayString(($setup.state.page - 1) * $setup.state.size + (idx + 1)), 1),
                      _createElementVNode("div", _hoisted_15, [
                        (item.isNotice == 1)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_16, [...(_cache[10] || (_cache[10] = [
                              _createElementVNode("img", {
                                src: "img/megaphone-fill.png",
                                alt: "notice"
                              }, null, -1)
                            ]))]))
                          : _createCommentVNode("", true),
                        (item.isSecret == 1)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_17, [...(_cache[11] || (_cache[11] = [
                              _createElementVNode("img", {
                                src: "img/lock-filled.png",
                                alt: "notice"
                              }, null, -1)
                            ]))]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_router_link, {
                          to: { name: 'ActionView', params: { stateIdx: $setup.state.stateIdx, id: item.idx } },
                          class: "elips_1"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.isSecret == 0 ? item.title : "비밀글 입니다."), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]),
                      (!$setup.state.isMobile)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("div", _hoisted_18, [
                              _cache[12] || (_cache[12] = _createElementVNode("span", { class: "mo_th" }, "조회수", -1)),
                              _createTextVNode(" " + _toDisplayString($setup.CommonUtils.numberFormat(item.viewCnt)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_19, [
                              _cache[13] || (_cache[13] = _createElementVNode("span", { class: "mo_th" }, "작성자", -1)),
                              _createTextVNode(" " + _toDisplayString(item.isSecret == 0 ? item.writer : "익명"), 1)
                            ]),
                            _createElementVNode("div", _hoisted_20, [
                              _cache[14] || (_cache[14] = _createElementVNode("span", { class: "mo_th" }, "날짜", -1)),
                              _createTextVNode(" " + _toDisplayString($setup.CommonUtils.dateFormat(new Date(item.createDate), ".", true)), 1)
                            ])
                          ], 64))
                        : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                            _createElementVNode("div", _hoisted_22, [
                              _createElementVNode("div", _hoisted_23, [
                                _cache[15] || (_cache[15] = _createElementVNode("span", { class: "mo_th" }, "조회수", -1)),
                                _createTextVNode(" " + _toDisplayString($setup.CommonUtils.numberFormat(item.viewCnt)), 1)
                              ]),
                              _cache[17] || (_cache[17] = _createElementVNode("span", { class: "divider no_450" }, "｜", -1)),
                              _createElementVNode("div", _hoisted_24, [
                                _cache[16] || (_cache[16] = _createElementVNode("span", { class: "mo_th" }, "작성자", -1)),
                                _createTextVNode(" " + _toDisplayString(item.isSecret == 0 ? item.writer : "익명"), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_25, [
                              _cache[18] || (_cache[18] = _createElementVNode("span", { class: "mo_th" }, "날짜", -1)),
                              _createTextVNode(" " + _toDisplayString($setup.CommonUtils.dateFormatForMobile(new Date(item.createDate), ".", true)), 1)
                            ])
                          ]))
                    ])
                  ]))
                }), 128))
              : (_openBlock(), _createElementBlock("li", _hoisted_26, [...(_cache[19] || (_cache[19] = [
                  _createElementVNode("div", { class: "tr_div" }, [
                    _createElementVNode("div", {
                      class: "tb_subject",
                      style: {"justify-content":"center","width":"100%"}
                    }, "등록된 게시물이 없습니다.")
                  ], -1)
                ]))]))
          ])
        ]),
        ($setup.state.list.length !== 0)
          ? (_openBlock(), _createBlock(_component_PageBtn, {
              key: 0,
              currentPage: $setup.state.page,
              totalLength: $setup.state.totalLength,
              perPage: $setup.state.size,
              onOnPaging: $setup.handlePageChange
            }, null, 8, ["currentPage", "totalLength", "perPage", "onOnPaging"]))
          : _createCommentVNode("", true)
      ])
    ]),
    ($setup.state.isShowModal)
      ? (_openBlock(), _createBlock(_component_ModalDefault, {
          key: 0,
          type: $setup.state.modalTab,
          title: $setup.state.modalTitle,
          content: $setup.state.modalContent,
          onClose: $setup.closeModal,
          onCallback: $setup.callBackModal
        }, null, 8, ["type", "title", "content", "onClose", "onCallback"]))
      : _createCommentVNode("", true)
  ], 64))
}